<!-- <li class="panel"> -->
<div class="controparte">
	<p class="col-sm-2">
		<button (click)="emitEntity(datiPignoramento)" class="btn btn-primary associa"
			type="submit">Allega</button>
	</p>
	<div>
		<h4 class="titolo col-sm-3">{{datiPignoramento.terzo}}
		</h4>
		<p class="col-sm-3">
			Importo precettato: <strong>{{datiPignoramento.importoPrecettato? (datiPignoramento.importoPrecettato
				| euro) + ' &euro;': ''}}</strong>
		</p>
	</div>
</div>
<!-- </li> -->
